module.exports = __webpack_public_path__ + "img/box3-03.2afe7a4e.png";